(function () {
  'use strict';

  function setupCompare(root) {
    var range = root.querySelector('[data-irp-compare-range]');
    var overlay = root.querySelector('[data-irp-compare-overlay]');
    var divider = root.querySelector('[data-irp-compare-divider]');
    if (!range || !overlay || !divider) return;
    function paint() {
      var value = Math.max(0, Math.min(100, Number(range.value) || 50));
      overlay.style.clipPath = 'inset(0 0 0 ' + value + '%)';
      divider.style.left = value + '%';
      range.setAttribute('aria-valuetext', value + '% de la imagen anterior');
    }
    range.addEventListener('input', paint);
    paint();
  }

  function setupCompareViews(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-irp-compare-view-button]'));
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-irp-compare-view]'));
    if (buttons.length < 2 || views.length < 2) return;
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selectedView = button.getAttribute('data-irp-compare-view-button');
        buttons.forEach(function (item) {
          var isSelected = item === button;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-pressed', String(isSelected));
        });
        views.forEach(function (view) {
          view.hidden = view.getAttribute('data-irp-compare-view') !== selectedView;
        });
      });
    });
  }

  function setupCategoryNav(nav) {
    var details = Array.prototype.slice.call(nav.querySelectorAll('details'));
    details.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        details.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) details.forEach(function (item) { item.open = false; });
    });
    nav.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        details.forEach(function (item) { item.open = false; });
        var trigger = nav.querySelector('summary');
        if (trigger) trigger.focus();
      }
    });
  }

  var reviewRequests = {};
  var compatibilityStorageKey = 'irp_shopify_active_vehicle_v2';
  var catalogManager = { runId: 0, timer: null, rendering: false, filtered: false, records: [], context: null, showAll: false };
  var homeCatalogManager = { requestId: 0, recordsPromise: null, originalItems: null };

  function readCatalogSelection() {
    try {
      var stored = JSON.parse(localStorage.getItem(compatibilityStorageKey) || 'null');
      if (!stored || !stored.vehicle || Number(stored.expiresAt) <= Date.now()) return null;
      return { vehicle: stored.vehicle, showAll: Boolean(stored.showAll) };
    } catch (_) { return null; }
  }

  function catalogApiUrl() {
    var root = document.querySelector('[data-irp-api-url]');
    if (!root || !root.getAttribute('data-irp-api-url')) return '';
    if (location.hostname === '127.0.0.1' || location.hostname === 'localhost') {
      return new URLSearchParams(location.search).get('irpMock') === '1' ? 'http://127.0.0.1:3005' : 'http://127.0.0.1:3001';
    }
    return '/apps/irp-compatibilidades';
  }

  function catalogContext(root) {
    var scope = root || document;
    var grid = scope.querySelector('#product-grid');
    var container = scope.querySelector('#ProductGridContainer');
    if (!grid || !container || !grid.getAttribute('data-id')) return null;
    var totalPages = 1;
    container.querySelectorAll('.pagination a[href]').forEach(function (link) {
      var page = Number(new URL(link.href, location.href).searchParams.get('page') || 1);
      totalPages = Math.max(totalPages, page);
    });
    return {
      container: container,
      grid: grid,
      pageSize: Math.max(1, grid.querySelectorAll(':scope > li.grid__item').length || 24),
      sectionId: grid.getAttribute('data-id'),
      totalPages: totalPages
    };
  }

  function setCatalogLoading(context, loading, vehicle) {
    if (!context) return;
    var loader = context.container.querySelector('.irp-catalog-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'irp-catalog-loader';
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-live', 'polite');
      context.container.prepend(loader);
    }
    loader.textContent = loading ? 'Buscando productos compatibles' + (vehicle && vehicle.label ? ' con tu ' + vehicle.label : '') + '…' : '';
    loader.hidden = !loading;
    context.container.classList.toggle('irp-catalog-loading', loading);
    context.container.toggleAttribute('aria-busy', loading);
    document.documentElement.classList.remove('irp-compatibility-catalog-pending');
  }

  function catalogPageUrl(context, page) {
    var url = new URL(context.sourceUrl || location.href, location.origin);
    url.searchParams.delete('irp_page');
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', context.sectionId);
    return url.toString();
  }

  function parseCatalogRecords(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('#product-grid > li.grid__item')).map(function (card) {
      var metadata = card.querySelector('script[data-irp-card-catalog]');
      if (!metadata) return null;
      try {
        var product = JSON.parse(metadata.textContent || '{}').product;
        return product ? { node: card, product: product } : null;
      } catch (_) { return null; }
    }).filter(Boolean);
  }

  function loadCatalogRecords(context) {
    var requests = [];
    for (var page = 1; page <= context.totalPages; page += 1) {
      requests.push(fetch(catalogPageUrl(context, page), { headers: { Accept: 'text/html' } }).then(function (response) {
        if (!response.ok) throw new Error('No se pudo cargar una página del catálogo.');
        return response.text();
      }).then(parseCatalogRecords));
    }
    return Promise.all(requests).then(function (pages) {
      var seen = {};
      return pages.flat().filter(function (record) {
        var key = String(record.product.productId || record.product.handle || '');
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    });
  }

  function catalogCompatibilityRank(record, statuses) {
    var variantStatuses = (record.product.variants || []).map(function (variant) {
      return statuses[String(variant.variantId)] || 'unknown';
    });
    if (variantStatuses.includes('compatible')) return 0;
    if (variantStatuses.includes('universal')) return 2;
    return 1;
  }

  function sortCatalogRecordsByCompatibility(records, statuses, showAll) {
    return records.map(function (record, index) {
      return { record: record, index: index, rank: catalogCompatibilityRank(record, statuses) };
    }).filter(function (entry) {
      return showAll || entry.rank !== 1;
    }).sort(function (left, right) {
      return left.rank - right.rank || left.index - right.index;
    }).map(function (entry) {
      return entry.record;
    });
  }

  function resolveCatalogCompatibility(apiUrl, vehicle, records, showAll) {
    var seen = {};
    var items = [];
    records.forEach(function (record) {
      (record.product.variants || []).forEach(function (variant) {
        var sku = String(variant.sku || '').trim();
        var variantId = String(variant.variantId || '');
        var key = variantId + '|' + sku.toUpperCase();
        if (!sku || seen[key]) return;
        seen[key] = true;
        items.push({ productId: String(record.product.productId), variantId: variantId, sku: sku });
      });
    });
    var requests = [];
    for (var offset = 0; offset < items.length; offset += 50) {
      requests.push(fetch(apiUrl + '/shopify/lote', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ vehiclePublicId: vehicle.publicId, items: items.slice(offset, offset + 50) })
      }).then(function (response) {
        if (!response.ok) throw new Error('No se pudo verificar la compatibilidad del catálogo.');
        return response.json();
      }));
    }
    return Promise.all(requests).then(function (responses) {
      var statuses = {};
      responses.forEach(function (response) {
        (response.items || []).forEach(function (item) {
          statuses[String(item.variantId)] = item.status;
        });
      });
      return sortCatalogRecordsByCompatibility(records, statuses, showAll);
    });
  }

  function compatiblePageNumbers(total, current) {
    var pages = [];
    for (var page = 1; page <= total; page += 1) {
      if (page === 1 || page === total || Math.abs(page - current) <= 1) pages.push(page);
      else if (pages[pages.length - 1] !== null) pages.push(null);
    }
    return pages;
  }

  function compatiblePageUrl(page) {
    var url = new URL(location.href);
    url.searchParams.delete('page');
    if (page > 1) url.searchParams.set('irp_page', String(page));
    else url.searchParams.delete('irp_page');
    return url;
  }

  function updateCompatibleCount(count, showAll) {
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (node) {
      node.textContent = count + (showAll ? (count === 1 ? ' producto' : ' productos') : (count === 1 ? ' producto compatible' : ' productos compatibles'));
    });
  }

  function renderCompatibleCatalog(context, records, requestedPage, pushHistory, showAll) {
    var totalPages = Math.max(1, Math.ceil(records.length / context.pageSize));
    var page = Math.max(1, Math.min(totalPages, Number(requestedPage) || 1));
    var start = (page - 1) * context.pageSize;
    catalogManager.rendering = true;
    context.grid.replaceChildren();
    records.slice(start, start + context.pageSize).forEach(function (record) {
      context.grid.appendChild(document.importNode(record.node, true));
    });
    if (!records.length) {
      var empty = document.createElement('li');
      empty.className = 'irp-compatible-catalog-empty';
      empty.innerHTML = '<strong>No encontramos productos compatibles.</strong><span>Podés cambiar el auto o activar “Ver productos no compatibles”.</span>';
      context.grid.appendChild(empty);
    }
    setupProductReviewSurfaces(context.grid);

    var pagination = context.container.querySelector('.pagination-wrapper');
    if (!pagination) {
      pagination = document.createElement('div');
      context.grid.parentElement.appendChild(pagination);
    }
    pagination.className = 'pagination-wrapper irp-compatible-pagination';
    pagination.replaceChildren();
    if (totalPages > 1) {
      var nav = document.createElement('nav');
      nav.className = 'pagination';
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', showAll ? 'Paginación de productos' : 'Paginación de productos compatibles');
      var list = document.createElement('ul');
      list.className = 'pagination__list list-unstyled';
      compatiblePageNumbers(totalPages, page).forEach(function (pageNumber) {
        var item = document.createElement('li');
        if (pageNumber === null) item.textContent = '…';
        else {
          var link = document.createElement('a');
          link.className = 'pagination__item link' + (pageNumber === page ? ' pagination__item--current light' : '');
          link.href = compatiblePageUrl(pageNumber).toString();
          link.textContent = String(pageNumber);
          if (pageNumber === page) link.setAttribute('aria-current', 'page');
          link.addEventListener('click', function (event) {
            event.preventDefault();
            renderCompatibleCatalog(context, records, pageNumber, true, showAll);
          });
          item.appendChild(link);
        }
        list.appendChild(item);
      });
      nav.appendChild(list);
      pagination.appendChild(nav);
    }
    updateCompatibleCount(records.length, showAll);
    var targetUrl = compatiblePageUrl(page);
    history[pushHistory ? 'pushState' : 'replaceState']({}, '', targetUrl);
    if (pushHistory) window.scrollTo({ top: Math.max(0, context.grid.getBoundingClientRect().top + window.scrollY - 220), behavior: 'smooth' });
    window.setTimeout(function () { catalogManager.rendering = false; }, 0);
  }

  function restoreUnfilteredCatalog() {
    document.documentElement.classList.remove('irp-compatibility-catalog-pending');
    var context = catalogContext();
    if (context) setCatalogLoading(context, false, null);
    if (catalogManager.filtered) location.reload();
  }

  function refreshCompatibleCatalog() {
    var context = catalogContext();
    if (!context) return;
    window.IRPC = 1;
    var selection = readCatalogSelection();
    var vehicle = selection && selection.vehicle;
    var showAll = Boolean(selection && selection.showAll);
    var apiUrl = catalogApiUrl();
    if (!vehicle || !apiUrl) {
      restoreUnfilteredCatalog();
      return;
    }
    var runId = ++catalogManager.runId;
    setCatalogLoading(context, true, vehicle);
    loadCatalogRecords(context).then(function (records) {
      if (runId !== catalogManager.runId) return Promise.reject(new Error('stale'));
      return resolveCatalogCompatibility(apiUrl, vehicle, records, showAll);
    }).then(function (orderedRecords) {
      if (runId !== catalogManager.runId) return;
      catalogManager.filtered = true;
      catalogManager.records = orderedRecords;
      catalogManager.context = context;
      catalogManager.showAll = showAll;
      var requestedPage = Number(new URL(location.href).searchParams.get('irp_page') || new URL(location.href).searchParams.get('page') || 1);
      renderCompatibleCatalog(context, orderedRecords, requestedPage, false, showAll);
      setCatalogLoading(context, false, vehicle);
    }).catch(function (error) {
      if (error.message !== 'stale') console.error('IRP_COMPATIBLE_CATALOG_FAILED', error);
      if (runId === catalogManager.runId) setCatalogLoading(context, false, vehicle);
    });
  }

  function scheduleCompatibleCatalog() {
    window.clearTimeout(catalogManager.timer);
    catalogManager.timer = window.setTimeout(refreshCompatibleCatalog, 80);
  }

  function observeCompatibleCatalog() {
    var root = document.body;
    if (!root || root.dataset.irpCompatibleCatalogObserved === 'true') return;
    root.dataset.irpCompatibleCatalogObserved = 'true';
    new MutationObserver(function (mutations) {
      if (catalogManager.rendering) return;
      var changed = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches('#ProductGridContainer, #product-grid')
            || node.querySelector('#ProductGridContainer, #product-grid')
          );
        });
      });
      if (changed) {
        var selection = readCatalogSelection();
        if (selection && selection.vehicle && !selection.showAll) {
          document.documentElement.classList.add('irp-compatibility-catalog-pending');
        }
        scheduleCompatibleCatalog();
      }
    }).observe(root, { childList: true, subtree: true });
  }

  function setupStickyVehicleSelector() {
    var selector = document.querySelector('.irp-global-compatibility-selector');
    if (!selector) return;
    selector.id = 'IrpGlobalCompatibilitySelector';
    document.documentElement.style.setProperty('--irp-vehicle-selector-height', '0px');
  }

  function updateVehicleOverlayTop() {
    var header = document.querySelector('.section-header');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--irp-vehicle-overlay-top', Math.round(top) + 'px');

    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var toggle = Array.from(document.querySelectorAll('[data-irp-vehicle-toggle]')).find(function (button) {
      var rect = button.getBoundingClientRect();
      return button.offsetParent !== null && rect.width > 0 && rect.height > 0;
    });
    if (!toggle) return;
    var toggleRect = toggle.getBoundingClientRect();
    var gutter = 16;
    var width = Math.min(440, window.innerWidth - gutter * 2);
    var left = Math.max(gutter, Math.min(toggleRect.right - width, window.innerWidth - width - gutter));
    document.documentElement.style.setProperty('--irp-vehicle-overlay-left', Math.round(left) + 'px');
    document.documentElement.style.setProperty('--irp-vehicle-overlay-width', Math.round(width) + 'px');
  }

  function setVehicleOverlay(open) {
    var selector = document.querySelector('.irp-global-compatibility-selector');
    if (!selector) return;
    if (open) {
      var main = document.querySelector('main#MainContent, main[role="main"], main');
      if (
        (selector.classList.contains('is-hero-embedded') || selector.classList.contains('is-product-embedded'))
        && main
        && main.parentNode
      ) {
        selector.classList.remove('is-hero-embedded', 'is-product-embedded');
        main.parentNode.insertBefore(selector, main);
      }
      updateVehicleOverlayTop();
    }
    selector.classList.toggle('is-vehicle-overlay-open', open);
    document.documentElement.classList.toggle('irp-vehicle-overlay-open', open);
    document.querySelectorAll('[data-irp-vehicle-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
    });
    if (!open) mountPreferredVehicleSelector();
  }

  function updateVehicleToggleState(selection) {
    var hasVehicle = Boolean(selection && selection.vehicle);
    document.querySelectorAll('[data-irp-vehicle-toggle]').forEach(function (button) {
      button.classList.toggle('is-active', hasVehicle);
      button.dataset.irpVehicleSelected = String(hasVehicle);
      var accessibleLabel = button.querySelector('.visually-hidden');
      if (accessibleLabel) accessibleLabel.textContent = hasVehicle ? 'Cambiar auto seleccionado' : 'Seleccionar auto';
    });
  }

  function restoreGlobalVehicleSelector(selector) {
    var main = document.querySelector('main#MainContent, main[role="main"], main');
    selector.classList.remove('is-hero-embedded', 'is-product-embedded', 'is-vehicle-overlay-open');
    if (main && main.parentNode && selector.nextElementSibling !== main) main.parentNode.insertBefore(selector, main);
  }

  function mountProductVehicleSelector() {
    var selector = document.querySelector('.irp-global-compatibility-selector');
    var slot = document.querySelector('[data-irp-product-vehicle-slot]');
    var wrapper = document.querySelector('[data-irp-product-vehicle-check]');
    if (!selector || !slot || !wrapper || selector.dataset.irpInitialized !== 'true') return false;
    var selection = readCatalogSelection();
    var hasVehicle = Boolean(selection && selection.vehicle);
    wrapper.hidden = hasVehicle;
    if (hasVehicle) {
      if (selector.parentNode === slot) restoreGlobalVehicleSelector(selector);
      return false;
    }
    selector.id = 'IrpGlobalCompatibilitySelector';
    selector.classList.remove('is-hero-embedded', 'is-vehicle-overlay-open');
    selector.classList.add('is-product-embedded');
    if (selector.parentNode !== slot) slot.replaceChildren(selector);
    return true;
  }

  function mountHeroVehicleSelector() {
    var selector = document.querySelector('.irp-global-compatibility-selector');
    var slot = document.querySelector('[data-irp-hero-vehicle-slot]');
    if (!selector || !slot || selector.dataset.irpInitialized !== 'true') return false;
    selector.id = 'IrpGlobalCompatibilitySelector';
    selector.classList.remove('is-product-embedded');
    selector.classList.add('is-hero-embedded');
    if (selector.parentNode !== slot) slot.replaceChildren(selector);
    return true;
  }

  function mountPreferredVehicleSelector() {
    var selector = document.querySelector('.irp-global-compatibility-selector');
    if (selector && selector.classList.contains('is-vehicle-overlay-open')) return true;
    return mountProductVehicleSelector() || mountHeroVehicleSelector();
  }

  function observeHeroVehicleSelector() {
    if (mountPreferredVehicleSelector() || document.documentElement.dataset.irpHeroVehicleObserver === 'true') return;
    document.documentElement.dataset.irpHeroVehicleObserver = 'true';
    var observer = new MutationObserver(function () {
      if (!mountPreferredVehicleSelector()) return;
      observer.disconnect();
      delete document.documentElement.dataset.irpHeroVehicleObserver;
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-irp-initialized'] });
  }

  function setupVehicleToggle(scope) {
    (scope || document).querySelectorAll('[data-irp-vehicle-toggle]').forEach(function (button) {
      if (button.dataset.irpVehicleToggleInitialized === 'true') return;
      button.dataset.irpVehicleToggleInitialized = 'true';
      button.addEventListener('click', function () {
        var selector = document.querySelector('.irp-global-compatibility-selector');
        if (!selector) return;
        var shouldOpen = !selector.classList.contains('is-vehicle-overlay-open');
        setVehicleOverlay(shouldOpen);
        if (shouldOpen) {
          var drawer = document.getElementById('Details-menu-drawer-container');
          if (drawer) {
            drawer.removeAttribute('open');
            drawer.classList.remove('menu-opening');
          }
        }
      });

      var drawerToggle = document.querySelector('#Details-menu-drawer-container > summary');
      if (drawerToggle) drawerToggle.addEventListener('click', function () {
        setVehicleOverlay(false);
      });
    });

    updateVehicleToggleState(readCatalogSelection());

    if (document.documentElement.dataset.irpVehicleOverlayUi === 'true') return;
    document.documentElement.dataset.irpVehicleOverlayUi = 'true';
    document.addEventListener('click', function (event) {
      var selector = document.querySelector('.irp-global-compatibility-selector.is-vehicle-overlay-open');
      var eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
      if (
        !selector
        || selector.contains(event.target)
        || eventPath.indexOf(selector) !== -1
        || event.target.closest('[data-irp-vehicle-toggle]')
      ) return;
      setVehicleOverlay(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setVehicleOverlay(false);
    });
    window.addEventListener('resize', function () {
      if (document.querySelector('.irp-global-compatibility-selector.is-vehicle-overlay-open')) updateVehicleOverlayTop();
    });
    window.addEventListener('scroll', function () {
      if (document.querySelector('.irp-global-compatibility-selector.is-vehicle-overlay-open')) updateVehicleOverlayTop();
    }, { passive: true });
  }

  function restoreHomeCatalog(root, grid) {
    if (!homeCatalogManager.originalItems) return;
    grid.replaceChildren.apply(grid, homeCatalogManager.originalItems.map(function (item) {
      var clone = item.cloneNode(true);
      clone.hidden = false;
      clone.classList.remove('irp-product-filtered');
      return clone;
    }));
    setupProductReviewSurfaces(grid);
    root.classList.remove('irp-home-catalog-loading');
    root.removeAttribute('data-irp-home-catalog-error');
    root.removeAttribute('aria-busy');
  }

  function loadHomeCatalogRecords(root) {
    if (homeCatalogManager.recordsPromise) return homeCatalogManager.recordsPromise;
    var sourceUrl = root.getAttribute('data-irp-home-catalog-source') || '/collections/all';
    homeCatalogManager.recordsPromise = fetch(sourceUrl, { headers: { Accept: 'text/html' } }).then(function (response) {
      if (!response.ok) throw new Error('No se pudo cargar el catálogo para la portada.');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var context = catalogContext(doc);
      if (!context) throw new Error('No se encontró la grilla del catálogo.');
      context.sourceUrl = sourceUrl;
      return loadCatalogRecords(context);
    });
    return homeCatalogManager.recordsPromise;
  }

  function refreshHomeCompatibleCatalog() {
    var root = document.querySelector('[data-irp-home-catalog]');
    if (!root) return;
    var grid = root.querySelector('.product-grid');
    if (!grid) return;
    if (!homeCatalogManager.originalItems) {
      homeCatalogManager.originalItems = Array.from(grid.children).map(function (item) { return item.cloneNode(true); });
    }
    var selection = readCatalogSelection();
    if (!selection || !selection.vehicle) {
      restoreHomeCatalog(root, grid);
      return;
    }
    var requestId = ++homeCatalogManager.requestId;
    root.classList.add('irp-home-catalog-loading');
    root.removeAttribute('data-irp-home-catalog-error');
    root.setAttribute('aria-busy', 'true');
    loadHomeCatalogRecords(root).then(function (records) {
      return resolveCatalogCompatibility(catalogApiUrl(), selection.vehicle, records, false);
    }).then(function (records) {
      if (requestId !== homeCatalogManager.requestId) return;
      var columns = Math.max(1, Number(root.getAttribute('data-irp-home-catalog-columns')) || 3);
      var limit = Math.max(columns, Number(root.getAttribute('data-irp-home-catalog-limit')) || columns);
      var visibleCount = Math.min(limit, records.length);
      if (visibleCount > columns) visibleCount -= visibleCount % columns;
      var itemClass = homeCatalogManager.originalItems[0] ? homeCatalogManager.originalItems[0].className : 'grid__item';
      var sectionId = root.getAttribute('data-id') || 'home-compatible';
      var items = records.slice(0, visibleCount).map(function (record, index) {
        var item = document.importNode(record.node, true);
        item.className = itemClass;
        item.id = 'Slide-' + sectionId + '-' + (index + 1);
        item.hidden = false;
        item.classList.remove('irp-product-filtered');
        item.style.setProperty('--animation-order', String(index + 1));
        return item;
      });
      if (items.length) grid.replaceChildren.apply(grid, items);
      else restoreHomeCatalog(root, grid);
      setupProductReviewSurfaces(grid);
      root.classList.remove('irp-home-catalog-loading');
      root.removeAttribute('aria-busy');
      window.dispatchEvent(new Event('resize'));
    }).catch(function (error) {
      if (requestId !== homeCatalogManager.requestId) return;
      root.setAttribute('data-irp-home-catalog-error', error && error.message ? error.message : 'Error desconocido');
      var message = document.createElement('li');
      message.className = 'irp-home-catalog-message';
      message.textContent = 'No pudimos cargar los productos compatibles. Reintentá en unos instantes.';
      grid.replaceChildren(message);
      root.classList.remove('irp-home-catalog-loading');
      root.removeAttribute('aria-busy');
    });
  }

  function setupHomeCompatibleCatalog() {
    if (document.documentElement.dataset.irpHomeCompatibleCatalog === 'true') return;
    document.documentElement.dataset.irpHomeCompatibleCatalog = 'true';
    refreshHomeCompatibleCatalog();
    window.addEventListener('irp:vehicle-changed', refreshHomeCompatibleCatalog);
  }

  function loadProductReviews(root) {
    var sku = root.getAttribute('data-sku');
    var api = catalogApiUrl() || root.getAttribute('data-api-url');
    if (!sku || !api) return Promise.resolve(null);
    var key = api.replace(/\/$/, '') + '|' + sku.trim().toUpperCase();
    if (!reviewRequests[key]) {
      reviewRequests[key] = fetch(api.replace(/\/$/, '') + '/shopify/opiniones?sku=' + encodeURIComponent(sku), { headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('reviews'); return response.json(); })
        .catch(function () { return null; });
    }
    return reviewRequests[key];
  }

  function renderProductReviewPreview(root, payload) {
    if (!payload || !payload.items || !payload.items.length) {
      root.hidden = true;
      return;
    }
    var stars = root.querySelector('[data-review-preview-stars]');
    var count = root.querySelector('[data-review-preview-count]');
    if (!stars || !count) return;
    var total = Number(payload.totalItems) || payload.items.length;
    var average = Math.max(0, Math.min(5, Number(payload.averageRating) || 0));
    stars.style.setProperty('--rating-percent', (average / 5 * 100) + '%');
    root.setAttribute('aria-label', average.toFixed(1) + ' de 5 estrellas. Ir a ' + total + (total === 1 ? ' reseña' : ' reseñas'));
    count.textContent = total + (total === 1 ? ' reseña' : ' reseñas');
    root.hidden = false;
  }

  function renderProductCardReview(root, payload) {
    if (!payload || !payload.items || !payload.items.length) {
      root.hidden = true;
      return;
    }
    var stars = root.querySelector('[data-irp-card-review-stars]');
    var count = root.querySelector('[data-irp-card-review-count]');
    if (!stars || !count) return;
    var total = Number(payload.totalItems) || payload.items.length;
    var average = Math.max(0, Math.min(5, Number(payload.averageRating) || 0));
    stars.style.setProperty('--rating-percent', (average / 5 * 100) + '%');
    count.textContent = '(' + total + ')';
    root.setAttribute('aria-label', average.toFixed(1) + ' de 5 estrellas. ' + total + (total === 1 ? ' reseña' : ' reseñas'));
    root.hidden = false;
  }

  function renderProductReviewList(root, payload) {
    var target = root.querySelector('[data-review-list]');
    var summary = root.querySelector('[data-review-summary]');
    if (!target || !summary) return;
    if (!payload || !payload.items || !payload.items.length) {
      root.hidden = true;
      return;
    }
    var total = Number(payload.totalItems) || payload.items.length;
    summary.textContent = Number(payload.averageRating).toFixed(1) + ' / 5 · ' + total + (total === 1 ? ' opinión de comprador' : ' opiniones de compradores');
    target.innerHTML = '';
    payload.items.forEach(function (review) {
      var article = document.createElement('article');
      article.className = 'irp-product-review';
      var rating = Math.max(1, Math.min(5, Number(review.rating) || 1));
      var stars = Array.from({ length: 5 }, function (_, index) { return index < Math.round(rating) ? '★' : '☆'; }).join('');
      var date = review.reviewDate ? new Date(review.reviewDate).toLocaleDateString('es-AR') : '';
      article.innerHTML = '<div class="irp-product-review__stars" aria-label="' + rating + ' de 5 estrellas">' + stars + '</div>' +
        '<p class="irp-product-review__comment"></p><footer class="irp-product-review__meta">Compra realizada a través de nuestros canales de venta' + (date ? ' · ' + date : '') + '</footer>';
      article.querySelector('.irp-product-review__comment').textContent = review.comment;
      target.appendChild(article);
    });
    root.hidden = false;
  }

  function setupProductReviewSurfaces(scope) {
    (scope || document).querySelectorAll('[data-irp-review-preview], [data-irp-product-reviews], [data-irp-card-review]').forEach(function (root) {
      loadProductReviews(root).then(function (payload) {
        if (root.hasAttribute('data-irp-card-review')) renderProductCardReview(root, payload);
        else if (root.hasAttribute('data-irp-review-preview')) renderProductReviewPreview(root, payload);
        else renderProductReviewList(root, payload);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-irp-compare]').forEach(setupCompare);
    (scope || document).querySelectorAll('[data-irp-compare-views]').forEach(setupCompareViews);
    (scope || document).querySelectorAll('[data-irp-category-nav]').forEach(setupCategoryNav);
    setupProductReviewSurfaces(scope || document);
    setupStickyVehicleSelector();
    observeHeroVehicleSelector();
    setupVehicleToggle(scope || document);
    setupHomeCompatibleCatalog();
    if (scope === document || !scope) {
      observeCompatibleCatalog();
      scheduleCompatibleCatalog();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var slot = event.target.querySelector && event.target.querySelector('[data-irp-hero-vehicle-slot], [data-irp-product-vehicle-slot]');
    var selector = slot && slot.querySelector('.irp-global-compatibility-selector');
    var main = document.querySelector('main#MainContent, main[role="main"], main');
    if (selector && main && main.parentNode) {
      selector.classList.remove('is-hero-embedded', 'is-product-embedded', 'is-vehicle-overlay-open');
      main.parentNode.insertBefore(selector, main);
    }
  });
  window.addEventListener('irp:vehicle-changed', function (event) {
    updateVehicleToggleState(event.detail && event.detail.vehicle ? { vehicle: event.detail.vehicle } : null);
    if (event.detail && event.detail.selected) setVehicleOverlay(false);
    mountPreferredVehicleSelector();
    scheduleCompatibleCatalog();
  });
  window.addEventListener('popstate', function () {
    if (!catalogManager.records.length || !catalogManager.context) return;
    renderCompatibleCatalog(catalogManager.context, catalogManager.records, Number(new URL(location.href).searchParams.get('irp_page') || 1), false, catalogManager.showAll);
  });
})();
